import logo from "./Logo.png";
import "./Header.css";
import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { spacing } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

const Header = ({children}) => {
  const navigate = useNavigate();

  return (
    <header>
      <div className="header">
        <div >
        <img
          src={logo}
          alt="logo"
         
          m={2}
          onClick={() => {
            navigate("/");
          }}
        />
        </div>
        {children}
      </div>
    </header>
  );
};
export default Header;
